module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('p', [_vm._v("Documents Partagés")]), _c('br'), _vm._v(" "), _c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-docs row"
  }, [_vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), _vm._v(" "), (_vm.docs.length === 0) ? _c('div', {
    staticClass: "no-docs"
  }, [_vm._v("\n\t\t\t\tPas de document pour le moment\n\t\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95894b3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/SharedDocs.vue
// module id = 1161
// module chunks = 0